export default __webpack_public_path__ + "static/media/CAPInstructionImage1.e7d7d58f.svg";